<template>
  <div>
    <table class="table table-striped" style="border-bottom: 1px solid #dee2e6">
      <tbody>
        <tr>
          <td>Ship Particular</td>
          <td class="font-medium">-</td>
          <td>Equipment</td>
          <td class="font-medium">-</td>
        </tr>
        <tr>
          <td>Job Code</td>
          <td class="font-medium">{{
            maintenanceDetailData.jobCode ?? '-'
          }}</td>
          <td>Job Name</td>
          <td class="font-medium">{{
            maintenanceDetailData.jobName ?? '-'
          }}</td>
        </tr>
        <tr>
          <td>Job Class</td>
          <td class="font-medium">
            {{
              `${maintenanceDetailData.jobClass.jobClassCode} - ${maintenanceDetailData.jobClass.jobClass}`
            }}</td
          >
          <td>Job Type</td>
          <td class="font-medium">
            {{ maintenanceDetailData.jobType.jobTypeCode }}
          </td>
        </tr>
        <tr>
          <td>Trigger</td>
          <td class="font-medium">
            {{ maintenanceDetailData.trigger }}
          </td>
          <td>Frequency</td>
          <td class="font-medium"
            >{{ maintenanceDetailData.interval }}{{ ' ' }}
            {{
              maintenanceDetailData.trigger == 'CALENDAR' ? 'Month' : 'Hours'
            }}</td
          >
        </tr>
        <tr>
          <td>Job Description</td>
          <td class="font-medium" colspan="3">
            {{ maintenanceDetailData.jobType.description }}
          </td>
        </tr>
        <tr>
          <td>Notes</td>
          <td class="font-medium" colspan="3">
            <p v-html="maintenanceDetailData.notes">
              {{ maintenanceDetailData.notes || '-' }}
            </p></td
          >
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'MaintenanceInitInfo',
  props: {
    maintenanceDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style scoped>
.font-medium {
  font-weight: 500;
}
table td {
  min-width: 180px;
}
</style>
